import { Prescription } from '../../interfaces/prescription';
import { Prescriber } from '../../interfaces/users';
import { PrescriberConfiguration } from '../../shared/prescriber';
import { TrackerEventService } from '../../containers/prescription/trackerEventService';
import { logger } from '../../helpers/logger';

export const EMISSION_LOADING_BANNER_VIEW_EVENT = 'backoffice_campaign_envio_receita_view';
export const EMISSION_LOADING_BANNER_CLICK_EVENT = 'backoffice_campaign_envio_receita_click';

const EMISSION_LOADING_BANNER_FLOW = 'envio de receita';

export interface EmissionLoadingBannerEventContext {
  prescription: Prescription | null;
  prescriber: Prescriber | null;
  prescriberConfiguration: PrescriberConfiguration | null;
  idBanner: number;
  isMobile: boolean;
}

/**
 * Dispara o evento do banner patrocinado exibido no loading de assinatura e envio da receita.
 *
 * Como a receita pode ter vários medicamentos, `id_medicamento` e `id_medicamento_ean`
 * são enviados como listas, na mesma ordem dos itens da prescrição.
 *
 * @param eventName Nome do evento (view ou click).
 * @param context Dados da prescrição, do prescritor, do banner e do dispositivo.
 */
export function trackEmissionLoadingBannerEvent(eventName: string, context: EmissionLoadingBannerEventContext): void {
  const { prescription, prescriber, prescriberConfiguration, idBanner, isMobile } = context;

  if (!prescription) return;

  const items = prescription.Itens ?? [];

  TrackerEventService.track(prescription.idPrescricao, eventName, {
    flow: EMISSION_LOADING_BANNER_FLOW,
    id_prescricao: prescription.idPrescricao,
    codigo_validacao: prescription.CodigoValidacao,
    id_parceiro: prescriberConfiguration?.idParceiro ?? null,
    id_medico: prescriber?.idPrescritor ?? null,
    id_paciente: prescription.Paciente?.idPaciente ?? null,
    id_medicamento: items.map((item) => item.IdMedicamento),
    id_medicamento_ean: items.map((item) => item.ListaEANS?.[0] ?? null),
    id_banner: idBanner,
    ambiente: process.env.APP_ENV_NAME === 'production' ? 'prod' : 'hom',
    is_mobile: isMobile,
  }).catch((error) => {
    logger.error(`Erro ao enviar evento ${eventName} do banner do loading de emissão`, error);
  });
}
